module.exports = __webpack_public_path__ + "img/CoronaRedirect.6b436d31.jpg";